import { OpenStreetMapProvider } from 'leaflet-geosearch';

// Contants
import MAP from 'constants/map';

const provider = () =>
  new OpenStreetMapProvider({
    params: {
      in: MAP.BOUNDING_BOX_BRAZIL,
      format: 'json',
      addressdetails: 1,
      countrycodes: 'br',
    },
  });

export default provider;
